function arrayMove(items, oldIndex, newIndex) {

    if (oldIndex === null && newIndex === null) return items;

    const result = [...items];
    let itemToAdd;

    if (oldIndex !== null) {
        itemToAdd = result.splice(oldIndex, 1)[0];
    }

    if (newIndex !== null) {
        result.splice(newIndex, 0, itemToAdd);
    }

    return result;
}

export default arrayMove;
